module.exports = __webpack_public_path__ + "static/media/LGSmartBold__W.be498710.woff";